import axios from 'axios';

export const submit_hubspot_form = async (payload) => {
  const portalId = '19589967';
  const formGuid = '3b53a257-4333-4b80-a521-175fafaec380';
  const config = { // important!
    headers: {
      'Content-Type': 'application/json',
    }
  }

  const response = await axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    {
      portalId,
      formGuid,
      fields: [
        {
          name: 'firstname',
          value: payload.firstName,
        },
        {
          name: 'lastname',
          value: payload.lastName,
        },
        {
          name: 'email',
          value: payload.email,
        },
        {
          name: 'message',
          value: 'Organization name is' + payload.organizationName,
        },
      ],
    },
    config
  );
  debugger;
  return response;
}